export const GET_LOANS = 'getLoans';
